import { userService } from "../services";
import config from "../config/config";

export const VehicleAction = {
  deleteVehicles,
  gettingExistingVehicleAccess,
  addVehicleForAccess,
  fetchVehicleList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  vehicleTypeList,
  VehicleRefresh,
  etpOrderFetch,
  VehicleGpsRemove,
  vehicleStatusList,
  fetchpasswordGenerator,
  VehicleListForAddTrip,
  addVehicleForTrip,
  manualFuelEventsGenerated,
  twoStepAuthentication,
  lockStatusUpdate,
  generateOtp,
  validateOtp
};

async function validateOtp(payload) {
  try {

    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}api/v2/verify/otp?vehicleNumber=${payload.vehicleNumber}&otp=${payload.otp}`;

    let response = await userService.post(apiEndpoint);

    console.log(response);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response?.data?.message || "OTP verification failed");
      return null;
    }

  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function twoStepAuthentication(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.twoStepAuthentication
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function lockStatusUpdate(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.lockStatusUpdate
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function generateOtp(payload) {
  try {

    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}api/v1/generate/otp?vehicleNumber=${payload.vehicleNumber}`;

    let response = await userService.post(apiEndpoint);

    console.log(response);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response?.data?.message || "OTP generation failed");
      return null;
    }

  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchVehicleList(payload) {
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      vehicleType: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver,
      },
      site: {
        id: payload.siteId,
      },
      parentSiteId: payload?.parentId,
      vehicleIds: payload.vehicleIds,
      vendorId: payload.vendorId ? payload.vendorId : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      activeFuelSensor: payload.activeFuelSensor,
      forDropDown: payload.forDropDown,
    };

    //let apiEndpoint = `http://192.168.12.57:8082/${config.apiName.VehicleList}?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.VehicleList
    }?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    //debugger
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert("No Vehicle Available");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleListForAddTrip(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.vehicleListForAddTrip
    }?companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.UpdateVehicle
    }`;
    // let data = new FormData();
    // data.append('name', payload.name);
    // data.append('gender', payload.gender);
    // data.append('id', payload.id);
    // data.append('phoneNumber', payload.phoneNumber);
    // data.append('designation', payload.designation);
    // data.append('address', payload.address);
    // data.append('updatedBy', payload.updatedBy);
    // data.append('company', payload.company);
    // data.append('file', payload.file);
    // data.append('isActive', payload.isActive);

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status == 404) {
      //     // return response;
      //     alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload) {
  console.log(payload);
  // return false
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.AddVehicle
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    //debugger
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response?.data?.message?response?.data?.message:"Somthing went wrong!");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function addVehicleForTrip(payload) {
  console.log(payload);
  // return false
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.AddVehicleForTrip
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    //debugger
    if (response && response.status === 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.ActiveVehicle
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.VehicleById
    }?id=${payload.userId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleTypeList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.VehicleTypeList
    }`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleStatusList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.VehicleStatusList
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      console.log(response.data, "jhgyfgy");
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleRefresh(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.SyncVehicle
    }?vehicleNo=${payload.vehicleNo}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleGpsRemove(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.removeGpsFromVehicle
    }?companyId=${payload.companyId}&id=${payload.vehicleId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function etpOrderFetch(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.EtpOrder
    }?orderId=${payload.orderId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

// async function vehicleStatusList(payload) {

//     try {

//         let apiEndpoint =  `${JSON.parse(localStorage.getItem('config')).baseUrl}${config.apiName.VehicleStatusList}`

//         let response = await userService.post(apiEndpoint,payload);
//         console.log(response);
//         if (response && response.status == 200) {
//             console.log(response.data,"jhgyfgy")
//             return (response.data);
//         }
//         else {
//             console.log(response)
//             alert(response.data.message);

//             return null;
//         }
//     }
//     catch(error) {
//         console.log("error", error);
//         return null;
//     }
// }

async function addVehicleForAccess(payload) {
  try {
    const apiEndpoint =
      JSON.parse(localStorage.getItem("config")).baseUrl +
      config.apiName.vehicleAddForAccess;

    // const apiEndpoint =
    //   "http://192.168.12.24:8082/" + config.apiName.vehicleAddForAccess;

    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 201) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function gettingExistingVehicleAccess(payload) {
  try {
    const apiEndpoint =
      JSON.parse(localStorage.getItem("config")).baseUrl +
      config.apiName.existingVehicleAccess;

    // const apiEndpoint =
    //   "http://192.168.12.24:8082/" + config.apiName.existingVehicleAccess;

    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function deleteVehicles(payload) {
  try {
    const apiEndpoint =
      JSON.parse(localStorage.getItem("config")).baseUrl +
      config.apiName.deleteVehicles;

    // const apiEndpoint =
    //   "http://192.168.12.24:8082/" + config.apiName.deleteVehicles;

    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 201) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchpasswordGenerator(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.passwordGenerator
    }`;

    const response = await userService.post(apiEndpoint, payload);
    if (response) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function manualFuelEventsGenerated(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.manualFillEvent
    }`;

    const response = await userService.post(apiEndpoint, payload);
    if (response) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
